import { useState } from 'react';

export default function WorksheetSubmodalidadesHero() {
  const [showModal, setShowModal] = useState(false);

  const scrollToPratica = () => {
    const praticaSection = document.getElementById('pratica-interativa');
    if (praticaSection) {
      praticaSection.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  };

  return (
    <>
      <section className="relative bg-gradient-to-br from-indigo-50 via-purple-50 to-pink-50 py-20">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center max-w-4xl mx-auto">
            <div className="inline-flex items-center gap-2 bg-white/80 backdrop-blur-sm px-4 py-2 rounded-full mb-6 shadow-sm">
              <i className="ri-settings-3-line text-indigo-600 text-xl"></i>
              <span className="text-sm font-medium text-gray-700">Técnica de PNL Avançada</span>
            </div>

            <h1 className="text-5xl font-bold text-gray-900 mb-6">
              Worksheet de <span className="text-transparent bg-clip-text bg-gradient-to-r from-indigo-600 to-purple-600">Submodalidades</span>
            </h1>

            <p className="text-xl text-gray-600 mb-8 leading-relaxed">
              Aprenda a ajustar os "controles internos" da sua mente para transformar experiências negativas em neutras ou positivas
            </p>

            <div className="flex flex-wrap items-center justify-center gap-4 mb-12">
              <button
                onClick={scrollToPratica}
                className="px-8 py-4 bg-gradient-to-r from-indigo-600 to-purple-600 text-white rounded-full font-semibold hover:shadow-xl transition-all duration-300 hover:scale-105 whitespace-nowrap flex items-center gap-2"
              >
                <i className="ri-play-circle-line text-xl"></i>
                Começar Agora
              </button>
              <button
                onClick={() => setShowModal(true)}
                className="px-8 py-4 bg-white text-indigo-600 rounded-full font-semibold hover:shadow-lg transition-all duration-300 border-2 border-indigo-200 whitespace-nowrap flex items-center gap-2"
              >
                <i className="ri-question-line text-xl"></i>
                Como Funciona?
              </button>
            </div>

            <div className="grid md:grid-cols-3 gap-6 max-w-4xl mx-auto">
              <div className="bg-white/80 backdrop-blur-sm p-6 rounded-2xl shadow-sm hover:shadow-md transition-shadow">
                <div className="w-12 h-12 bg-gradient-to-br from-indigo-500 to-purple-500 rounded-xl flex items-center justify-center mb-4 mx-auto">
                  <i className="ri-eye-line text-white text-2xl"></i>
                </div>
                <h3 className="font-semibold text-gray-900 mb-2">Visuais</h3>
                <p className="text-sm text-gray-600">Brilho, tamanho, distância, cor, nitidez</p>
              </div>

              <div className="bg-white/80 backdrop-blur-sm p-6 rounded-2xl shadow-sm hover:shadow-md transition-shadow">
                <div className="w-12 h-12 bg-gradient-to-br from-green-500 to-emerald-500 rounded-xl flex items-center justify-center mb-4 mx-auto">
                  <i className="ri-volume-up-line text-white text-2xl"></i>
                </div>
                <h3 className="font-semibold text-gray-900 mb-2">Auditivas</h3>
                <p className="text-sm text-gray-600">Volume, tom, ritmo, localização</p>
              </div>

              <div className="bg-white/80 backdrop-blur-sm p-6 rounded-2xl shadow-sm hover:shadow-md transition-shadow">
                <div className="w-12 h-12 bg-gradient-to-br from-orange-500 to-red-500 rounded-xl flex items-center justify-center mb-4 mx-auto">
                  <i className="ri-hand-heart-line text-white text-2xl"></i>
                </div>
                <h3 className="font-semibold text-gray-900 mb-2">Cinestésicas</h3>
                <p className="text-sm text-gray-600">Temperatura, pressão, intensidade</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {showModal && (
        <div className="fixed inset-0 bg-black/50 backdrop-blur-sm z-50 flex items-center justify-center p-4" onClick={() => setShowModal(false)}>
          <div className="bg-white rounded-3xl max-w-2xl w-full p-8 shadow-2xl" onClick={(e) => e.stopPropagation()}>
            <div className="flex items-center justify-between mb-6">
              <h3 className="text-2xl font-bold text-gray-900">Os Controles Internos da Mente</h3>
              <button
                onClick={() => setShowModal(false)}
                className="w-10 h-10 flex items-center justify-center rounded-full hover:bg-gray-100 transition-colors"
              >
                <i className="ri-close-line text-2xl text-gray-500"></i>
              </button>
            </div>

            <div className="space-y-4 text-gray-700 leading-relaxed">
              <p>
                <strong className="text-indigo-600">Submodalidades</strong> são as qualidades específicas de nossas representações internas — como ajustar brilho, volume ou temperatura de uma experiência mental.
              </p>

              <div className="bg-indigo-50 p-4 rounded-xl">
                <p className="font-semibold text-indigo-900 mb-2">🧠 Princípio:</p>
                <p className="text-sm">
                  Assim como você ajusta brilho, contraste e volume em uma TV, pode ajustar as qualidades das suas memórias e pensamentos para mudar como se sente em relação a eles.
                </p>
              </div>

              <p>
                <strong>Exemplo prático:</strong> Uma memória negativa pode ser grande, brilhante e próxima. Ao torná-la pequena, escura e distante, a carga emocional diminui automaticamente.
              </p>

              <p className="text-sm text-gray-600 italic">
                Esta técnica foi desenvolvida por Richard Bandler e John Grinder, criadores da PNL, e é uma das ferramentas mais poderosas para mudança rápida de estado emocional.
              </p>
            </div>

            <button
              onClick={() => setShowModal(false)}
              className="w-full mt-6 px-6 py-3 bg-gradient-to-r from-indigo-600 to-purple-600 text-white rounded-xl font-semibold hover:shadow-lg transition-all whitespace-nowrap"
            >
              Entendi, vamos começar!
            </button>
          </div>
        </div>
      )}
    </>
  );
}